import produce from 'immer'

import { Constants } from './'

const initialState = {
  isRequest: true,
  skus: [],
  selectedSeller: null,
  error: {
    message: null,
    data: null
  }
}

const reducer = (state = initialState, action = {}) =>
  produce(state, draft => {
    switch (action.type) {
      case Constants.SKUS_GET: {
        draft.isRequest = true

        break
      }

      case Constants.SKUS_GET_SUCCESS: {
        const firstId = action.payload[0] ? action.payload[0].id : null

        draft.isRequest = false
        draft.skus = action.payload
        draft.selectedSeller = firstId

        break
      }

      case Constants.SKUS_GET_FAILURE: {
        draft.isRequest = false
        draft.error.message = action.payload.message
        draft.error.data = action.payload.data

        break
      }

      case Constants.SKU_SELECT: {
        draft.selectedSeller = action.payload

        break
      }

      default:
        return draft
    }
  })

export default reducer
